import React,{useRef,useEffect} from 'react';
import { Card, Button } from 'react-bootstrap';
import Stack from 'react-bootstrap/Stack';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../App.css';

const isValidURL = (string) => {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
};


function MyCard({data,p}){
  
  let link = `https://api.screenshotmachine.com?key=373db6&url=${data.homepage}&device=desktop&dimension=1200x700`;
  const elementRef = useRef(null);

  useEffect(()=>{
    if(!p){
      elementRef.current.style = `background-image: url(${link});`;
    }
  },[link,p])

  return (
    <Card bg='secondary' ref={elementRef} border='danger' text="white" >
      <Card.Img variant="top" src={link} />
      <Card.Body  size='sm'>
        <Card.Title>{data.name}</Card.Title>
        <Card.Text>{data.description}</Card.Text>
      </Card.Body>
      <Card.Body>
          <Stack gap={2} direction="horizontal">
            <Button target='_blank' rel="noreferrer" href={data.html_url} size='sm' variant="light" disabled={!isValidURL(data.html_url)}>
              Codigo fonte
            </Button>
            <Button target='_blank' rel="noreferrer" href={data.homepage} size='sm' variant="light" disabled={!isValidURL(data.homepage)}>
              Site
            </Button>
          </Stack>
      </Card.Body>
    </Card>
  );
};



function SecondCard({data}){

  let link = `https://api.screenshotmachine.com?key=373db6&url=${data.homepage}&device=desktop&dimension=1200x700`;
  const elementRef = useRef(null);

  return (
    <Card bg='secondary' 
    ref={elementRef} 
    border='danger' 
    text="white" >
      <Card.Img variant="top" src={link} />
    </Card>
  );
};




export {MyCard as default, SecondCard};